module.exports = __webpack_public_path__ + "static/github-a8648a33122c03408ce2d88e3e54e670.svg";